const KEY_ACCESS_TOKEN = "access_token";
const KEY_ACCESS_TOKEN_EXP = "access_token_exp";
const KEY_PKCE_STATE = "pkce_state";
const KEY_PKCE_CODE_VERIFIER = "pkce_code_verifier";
const KEY_REFRESH_TOKEN = "refresh_token";
const KEY_REFRESH_TOKEN_EXP = "refresh_token_exp";
const KEY_REALM = "realm";
const AUTH_API_POST_CONTENT_TYPE = "application/x-www-form-urlencoded; charset=UTF-8";
export { KEY_REALM, KEY_PKCE_STATE, KEY_ACCESS_TOKEN, KEY_REFRESH_TOKEN, KEY_ACCESS_TOKEN_EXP, KEY_REFRESH_TOKEN_EXP, KEY_PKCE_CODE_VERIFIER, AUTH_API_POST_CONTENT_TYPE, };
//# sourceMappingURL=constants.js.map